import { render, staticRenderFns } from "./User.vue?vue&type=template&id=00c7b5c4&"
import script from "@/scripts/components/column/user.js?vue&type=script&lang=js&"
export * from "@/scripts/components/column/user.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports